import type Pageable from 'models/Pageable';
import type { DivisionDetailVO, DivisionDetailVOModel } from 'models/vo/DivisionDetailVO';
import type { DivisionVO, DivisionVOModel } from 'models/vo/DivisionVO';
import http from 'utils/http';
import API_FI from 'utils/http/api/financier';

import type {
  CreateFiDivisionDTO,
  SearchFiDivisionDTO,
  SearchFiDivisionDetailByCodeDTO,
  UpdateFiDivisionDTO,
} from './request';

export const requestFiDivisionsRegister = async (data: CreateFiDivisionDTO): Promise<DivisionVOModel> =>
  await http.post<DivisionVO>({
    url: API_FI.DIVISIONS.DIVISIONS,
    data,
  });

export const requestFiDivisions = async (
  pageNumber: number,
  rowCount: number,
  searchValue?: SearchFiDivisionDTO,
): Promise<Pageable<DivisionVOModel[]>> =>
  await http.get<Pageable<DivisionVO[]>>({
    url: API_FI.DIVISIONS.DIVISIONS,
    data: {
      pageNumber,
      rowCount,
      ...searchValue,
    },
  });

export const requestFiDivisionByCode = async (data: SearchFiDivisionDetailByCodeDTO): Promise<DivisionDetailVOModel> =>
  await http.get<DivisionDetailVO>({
    url: API_FI.DIVISIONS.DIVISION_BY_CODE,
    data,
  });

export const requestFiDivisionById = async (divisionId: number): Promise<DivisionDetailVOModel> =>
  await http.get<DivisionDetailVO>({
    url: API_FI.DIVISIONS.DIVISION_DETAIL(divisionId),
  });

export const requestFiDivisionEdit = async (divisionId: number, data: UpdateFiDivisionDTO): Promise<DivisionVOModel> =>
  await http.put<DivisionVO>({
    url: API_FI.DIVISIONS.DIVISION_DETAIL(divisionId),
    data,
  });

export const requestFiDivisionDelete = async (divisionId: number): Promise<void> =>
  await http.delete({
    url: API_FI.DIVISIONS.DIVISION_DETAIL(divisionId),
  });
